import React from 'react';
import { Modal } from '../ui/Modal';
import { noteTemplates } from '../../data/notes';
import type { NoteTemplateKey } from '../../types/notes';
interface TemplatePickerProps {
  open: boolean;
  onClose: () => void;
  onPick: (key: NoteTemplateKey) => void;
}
export function TemplatePicker({
  open,
  onClose,
  onPick
}: TemplatePickerProps) {
  return <Modal open={open} onClose={onClose} title="Start a new note" description="Templates pre-fill editable headings and prompts. Delete anything you do not need — nothing is locked." width="lg" data-id="element-4032" data-mp="3un8gjnv1os1y">
      <ul className="grid gap-2 sm:grid-cols-2" data-id="element-4033" data-mp="m8gfdporip8f">
        {noteTemplates.map(template => <li key={template.key} data-id="element-4034" data-mp="h9naglnjk6jv">
            <button type="button" onClick={() => {
          onPick(template.key);
          onClose();
        }} className="w-full rounded-lg border border-line-strong px-4 py-3 text-left transition-colors duration-150 ease-out hover:border-brand-700 hover:bg-brand-50" data-id="element-4035" data-mp="haonuws1554r">
              <span className="block text-[13px] font-semibold text-ink" data-id="element-4036" data-mp="2zjtnv3ufk6ln">{template.label}</span>
              <span className="mt-0.5 block text-[12px] leading-5 text-ink-muted" data-id="element-4037" data-mp="33lf7d81gzj4t">
                {template.description}
              </span>
            </button>
          </li>)}
      </ul>
    </Modal>;
}